import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const BookmarkRemoveSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.10075 18.376C6.07852 18.661 6.13791 18.9464 6.27196 19.1989C6.40601 19.4513 6.60918 19.6604 6.8577 19.8016C7.10623 19.9429 7.38983 20.0104 7.67534 19.9964C7.96084 19.9823 8.23644 19.8872 8.46989 19.7223L12.0962 17.5669L15.719 19.7223C15.9528 19.8871 16.2286 19.9821 16.5143 19.9962C16.8001 20.0102 17.0839 19.9428 17.3327 19.8017C17.5815 19.6605 17.7851 19.4516 17.9197 19.1992C18.0542 18.9467 18.1143 18.6612 18.0927 18.376V6C18.0929 5.73731 18.0413 5.47717 17.9408 5.23446C17.8404 4.99174 17.693 4.7712 17.5073 4.58545C17.3216 4.3997 17.101 4.25239 16.8583 4.15194C16.6156 4.05148 16.3554 3.99985 16.0927 4H8.09961C7.83702 4 7.577 4.05174 7.33441 4.15226C7.09183 4.25279 6.87142 4.40012 6.6858 4.58586C6.50017 4.77159 6.35296 4.99208 6.25257 5.23472C6.15219 5.47736 6.1006 5.73741 6.10075 6V18.376Z"
          fill="#878A92"
        />
      </g>
      <circle cx="17" cy="17" r="4.5" fill="#878A92" stroke="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0087 15.178L17.0003 16.1855L15.992 15.1772C15.9389 15.1218 15.8752 15.0777 15.8048 15.0472C15.7344 15.0168 15.6586 15.0008 15.5819 15C15.5052 14.9993 15.4292 15.0138 15.3582 15.0429C15.2872 15.0719 15.2227 15.1148 15.1685 15.1691C15.1143 15.2234 15.0715 15.2879 15.0426 15.359C15.0136 15.43 14.9992 15.5061 15 15.5828C15.0009 15.6595 15.0171 15.7353 15.0476 15.8056C15.0781 15.876 15.1224 15.9396 15.1778 15.9926L16.1857 17.001L15.1786 18.0082C15.0733 18.117 15.0149 18.2628 15.0162 18.4142C15.0174 18.5656 15.078 18.7105 15.1851 18.8176C15.2921 18.9247 15.4369 18.9854 15.5883 18.9867C15.7397 18.988 15.8855 18.9297 15.9944 18.8245L17.0003 17.8153L18.0079 18.8233C18.061 18.8785 18.1247 18.9226 18.1951 18.9529C18.2655 18.9832 18.3412 18.9992 18.4178 19C18.4945 19.0007 18.5705 18.9861 18.6415 18.9571C18.7124 18.9281 18.7769 18.8853 18.8311 18.8311C18.8853 18.7769 18.9281 18.7124 18.9571 18.6414C18.9861 18.5705 19.0007 18.4945 19 18.4178C18.9992 18.3412 18.9832 18.2654 18.9529 18.195C18.9226 18.1246 18.8785 18.061 18.8233 18.0078L17.8174 17.0014L18.8245 15.9942C18.9298 15.8854 18.9881 15.7396 18.9869 15.5882C18.9857 15.4368 18.925 15.2919 18.818 15.1849C18.7109 15.0778 18.5661 15.017 18.4147 15.0157C18.2633 15.0145 18.1175 15.0727 18.0087 15.178Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  </span>
);

export default BookmarkRemoveSVG;
